import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export interface SetupResponse {
    id: string;
    setup_orders?: boolean | null;
    setup_comname?: string | null;
    setup_comaddress?: string | null;
    setup_comtele?: string | null;
    setup_comlogo?: string | null;
    setup_storeid?: string | null;
    setup_allowminus?: boolean | number | null;
    setup_invnotes?: string | null;
    setup_quotenotes?: string | null;
    setup_tax?: number | string | null;
    setup_pointscheme?: number | null;
    setup_tinno?: string | null;
    setup_regno?: string | null;
}

export const getSystemSetup = async (): Promise<SetupResponse> => {
    try {
        const response: ApiResponse<SetupResponse | null> = (
            await apiClient.get("/pos_setup", {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        if (!response.data) {
            throw new Error("No setup configuration found");
        }

        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error("Failed to fetch system setup");
    }
};

export const uploadCompanyLogo = async (file: File): Promise<SetupResponse> => {
    try {
        const formData = new FormData();
        formData.append("logo", file);

        const response: ApiResponse<SetupResponse | null> = (
            await apiClient.put("/pos_setup/logo", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        if (!response.data) {
            throw new Error("Logo upload succeeded without updated setup data");
        }

        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error("Failed to upload company logo");
    }
};
